import { render, staticRenderFns } from "./Errores.vue?vue&type=template&id=7f5f57ec&scoped=true"
import script from "./Errores.vue?vue&type=script&lang=js"
export * from "./Errores.vue?vue&type=script&lang=js"
import style0 from "./Errores.vue?vue&type=style&index=0&id=7f5f57ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5f57ec",
  null
  
)

export default component.exports